import { render } from "./KonTanna.vue?vue&type=template&id=863e563e"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/KonTanna.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "863e563e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('863e563e', __exports__)) {
    api.reload('863e563e', __exports__)
  }
  
  module.hot.accept("./KonTanna.vue?vue&type=template&id=863e563e", () => {
    api.rerender('863e563e', render)
  })

}


export default __exports__